var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu",on:{"click":function($event){return _vm.open()}}},[_vm._v(_vm._s(_vm.infos.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }